












































































/** @format */

import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
import moment from 'moment';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
// axios请求
import { operationRecordList } from '@/api/parking-lot-management/index';
import Utils from '@/utils/common';
// 字典
import { optionModeMap } from '@/types/parking-lot-management/dictionaries';
import * as _ from 'lodash';
@Component({
  name: 'DeviceOperation',
  components: {
    ParkingLotSearch
  }
})
// @Component
export default class DeviceOperation extends Mixins(TableMixin, TableWidthMixin) {
  optionsData: IOption[] = Utils.toLabelVal(optionModeMap);
  isWenvl: boolean = 'wenlv'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV); //岗位设置正荣定制化
  optionsData1: IOption[] =
    Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.park_operation_type || {}) || [];
  //搜索参数
  private filterParam: any = {
    parkIds: [], //选中的车场
    startDate: '',
    endDate: '',
    sendStatus: '',
    operatModule: '002', //操作模块
    createBy: '' //操作人
  };
  tableLoading = false;
  tableData: any[] = []; // 表数据
  synchronousOptions: IOption[] = _.concat(
    [{ label: '全部', value: '' }],
    Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.send_status)
  );
  //搜索时间配置
  private onTimeChange(date: any, dateString: any) {
    const [operateTimeStart, operateTimeEnd] = dateString;
    this.filterParam.startDate = operateTimeStart;
    this.filterParam.endDate = operateTimeEnd;
  }
  get defaultTime() {
    if (this.filterParam.startDate && this.filterParam.endDate) {
      return [
        this.moment(this.filterParam.startDate, 'YYYY-MM-DD'),
        this.moment(this.filterParam.endDate, 'YYYY-MM-DD')
      ];
    } else if (this.filterParam.startDate) {
      return [this.moment(this.filterParam.startDate, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  private moment = moment;
  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '操作人',
        dataIndex: 'createBy',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '操作模块',
        dataIndex: 'operatModule',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '操作类型',
        dataIndex: 'operateType',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      // {
      //   title: '操作内容',
      //   dataIndex: 'brand',
      //   width: 120,
      //   customRender: (text: any) => text || '--',
      // },
      // {
      //   title: '操作账号',
      //   dataIndex: 'ip',
      //   width: 120,
      //   customRender: (text: any) => text || '--',
      // },
      {
        title: '操作时间',
        dataIndex: 'strCreateTime',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '下发状态',
        dataIndex: 'sendStatus',
        width: 110,
        scopedSlots: { customRender: 'sendStatus' }
      }
    ];
  }

  // 生命周期初始化表单列表
  created() {
    this.fetchTableData();
  }
  /**
   * 请求数据列表
   */
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { parkIds, ...rest } = this.filterParam;
      const { status, code, msg, data } = await operationRecordList({
        ...rest,
        parkIds: this.filterParam.parkIds.join(','),
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }
  //清空table
  clear({ defaultParkIdList }) {
    this.filterParam = {
      parkIds: defaultParkIdList, //选中的车场
      startDate: '',
      endDate: '',
      sendStatus: '',
      operatModule: '002', //操作模块
      createBy: '' //操作人
    };
    this.searchTable();
  }
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.fetchTableData();
  }
  //获取下发状态
  getStatusName(val: any) {
    return this.$store.state.dictionaries.allDictionaries.send_status[val];
  }
}
